import { useEffect } from "react";

type UseEscapeKeypressOptions = {
  /** Ignore synthetic Escape, e.g. the one the command palette dispatches to close popovers. */
  trustedOnly?: boolean;
};

export default function useEscapeKeypress(
  conditional: boolean,
  callback: () => unknown,
  { trustedOnly = false }: UseEscapeKeypressOptions = {}
) {
  useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape" || !conditional) return;
      if (trustedOnly && !e.isTrusted) return;

      callback();
    };

    window.addEventListener("keydown", handleEscapeKey);
    return () => window.removeEventListener("keydown", handleEscapeKey);
  }, [callback, conditional, trustedOnly]);
}
